import { faBooks, faExternalLinkAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { EVENT_TYPES } from 'common/track-event-constants'

import { useClickTracking } from '../use-click-tracking'

export interface IResultComponentProps {
  label: string
  url: string
  id?: string
}

const useStyles = makeStyles((theme) => {
  return {
    root: {
      color: theme.palette.text.primary,
      padding: 0,
      '&:hover, &:focus': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
    listItem: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    listItemIcon: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(1),
      justifyContent: 'center',
    },
    externalLinkIconContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1),
    },
    externalLinkIcon: {
      color: theme.palette.text.secondary,
    },
  }
})

// Helpdocs are external pages, so this renders a plain anchor instead of LinkListItem
const ResultComponent = ({ id, label, url }: IResultComponentProps) => {
  const classes = useStyles()
  const trackClickFn = useClickTracking(EVENT_TYPES.LINK_RESULT_CLICK, url)

  return (
    <ListItem
      id={id}
      className={classes.root}
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={`Help: ${label} (opens in a new tab)`}
      aria-label={`Help: ${label} (opens in a new tab)`}
      disableGutters
      onClick={trackClickFn}
    >
      <div className={classes.listItem}>
        <ListItemIcon>
          <div className={classes.listItemIcon}>
            <FontAwesomeIcon
              icon={faBooks}
              size="lg"
              fixedWidth
            />
          </div>
        </ListItemIcon>
        <ListItemText primary={label} />
        <div className={classes.externalLinkIconContainer}>
          <FontAwesomeIcon
            className={classes.externalLinkIcon}
            icon={faExternalLinkAlt}
            size="sm"
          />
        </div>
      </div>
    </ListItem>
  )
}

export default ResultComponent
